import { render } from "./Layout5.vue?vue&type=template&id=1747e939&scoped=true&ts=true"
import script from "./Layout5.vue?vue&type=script&lang=ts"
export * from "./Layout5.vue?vue&type=script&lang=ts"

import "./Layout5.vue?vue&type=style&index=0&id=1747e939&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1747e939"]])

export default __exports__